export default __webpack_public_path__ + "static/methodology-d-c51568e88640ca9cc1a364b58787e60a.svg";